import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "LXDIA - India's Leading Influencer Marketing & PR Agency",
  description = "LXDIA connects brands with top influencers and creators. Expert influencer marketing, talent management, PR, and performance marketing services in India. Trusted by Amazon, Tata Motors, Policy Bazar & more.",
  keywords = "influencer marketing, influencer marketing agency India, PR agency, talent management, performance marketing, digital marketing agency, creator partnerships, brand growth, social media marketing, Instagram influencer marketing, YouTube influencer marketing",
  canonical = "https://lxdia.com/",
  ogImage = "https://lxdia.com/images/lxdia_logo.jpg",
  type = "website"
}) => {
  const schemaOrgJSONLD = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": "https://lxdia.com/#organization",
        "name": "LXDIA",
        "url": "https://lxdia.com",
        "logo": {
          "@type": "ImageObject",
          "url": "https://lxdia.com/images/lxdia_logo.jpg",
          "width": 512,
          "height": 512
        },
        "description": "India's leading influencer marketing, talent management, PR, and performance marketing agency",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Delhi",
          "addressCountry": "IN"
        },
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "+91-8287836426",
          "contactType": "customer service",
          "email": "collab@lxdia.com",
          "areaServed": "IN",
          "availableLanguage": ["en", "hi"]
        },
        "sameAs": [
          "https://www.instagram.com/lxdia.connect/",
          "https://www.linkedin.com/company/lxdia"
        ]
      },
      {
        "@type": "ProfessionalService",
        "@id": "https://lxdia.com/#service",
        "name": "LXDIA - Influencer Marketing & PR Agency",
        "image": "https://lxdia.com/images/lxdia_logo.jpg",
        "description": description,
        "provider": {
          "@id": "https://lxdia.com/#organization"
        },
        "areaServed": {
          "@type": "Country",
          "name": "India"
        },
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": "Digital Marketing Services",
          "itemListElement": [
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Influencer Marketing",
                "description": "Connect your brand with top influencers and creators for authentic campaigns that drive results"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Talent Management",
                "description": "Professional talent management services for creators and influencers"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Public Relations (PR)",
                "description": "Strategic PR campaigns to build and protect your brand reputation"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Performance Marketing",
                "description": "Data-driven performance marketing campaigns optimized for maximum ROI"
              }
            }
          ]
        }
      },
      {
        "@type": "WebSite",
        "@id": "https://lxdia.com/#website",
        "url": "https://lxdia.com",
        "name": "LXDIA",
        "description": "India's leading influencer marketing and PR agency",
        "publisher": {
          "@id": "https://lxdia.com/#organization"
        },
        "potentialAction": {
          "@type": "SearchAction",
          "target": "https://lxdia.com/?s={search_term_string}",
          "query-input": "required name=search_term_string"
        }
      },
      {
        "@type": "WebPage",
        "@id": canonical + "#webpage",
        "url": canonical,
        "name": title,
        "isPartOf": {
          "@id": "https://lxdia.com/#website"
        },
        "about": {
          "@id": "https://lxdia.com/#organization"
        },
        "description": description
      }
    ]
  };

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonical} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="LXDIA" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={canonical} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={ogImage} />

      {/* JSON-LD Schema */}
      <script type="application/ld+json">
        {JSON.stringify(schemaOrgJSONLD)}
      </script>
    </Helmet>
  );
};

export default SEO;
